import { render, staticRenderFns } from "./appTour.vue?vue&type=template&id=51ded1ed&scoped=true"
import script from "./appTour.vue?vue&type=script&lang=js"
export * from "./appTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ded1ed",
  null
  
)

export default component.exports